import { frame, cancelFrame } from '../../../frameloop/frame.mjs';
function observeTimeline(update, timeline) {
  var prevProgress;
  var onFrame = function onFrame() {
    var currentTime = timeline.currentTime;
    var percentage = currentTime === null ? 0 : currentTime.value;
    var progress = percentage / 100;
    if (prevProgress !== progress) {
      update(progress);
    }
    prevProgress = progress;
  };
  frame.update(onFrame, true);
  return function () {
    return cancelFrame(onFrame);
  };
}
export { observeTimeline };